import * as React from 'react';
import { Helmet } from 'react-helmet';

import type { CourseRichSearchCard as CourseRichSearchCardType } from 'bundles/seo/components/course-rich-search-card/types';

type Props = {
  data: CourseRichSearchCardType;
};

export const CourseRichSearchCard = (props: Props) => {
  const { data } = props;

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data, null, 2)}</script>
    </Helmet>
  );
};
